import React, {Component} from 'react';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import LocationTable from './LocationTable';

@connect(
    state => {
        return {
            customers: state.customers
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id) => {
                dispatch(customers.fetchCustomer(customer_id))
            }
        }
    }
)
export default class LocationList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            customer: null
        };
    }

    componentDidMount() {
        this.fetchCustomer()
    }

    @autobind
    fetchCustomer() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id)
    }

    render() {
        const id = this.props.match.params.id;
        const customer = this.props.customers.customer;
        if (!customer)
            return <h1>Loading</h1>;
        return (
            <DetailContainer id={id}>
                <LocationTable locations={customer.locations}/>
            </DetailContainer>
        )
    }
}

